import { observable, makeObservable } from 'mobx'

import { PayoutMethodResource } from './dtos/payout-method'
import { Model } from 'infra/model'
import { Id } from 'types/definitions'

/**
 * Payout method model.
 */
export class PayoutMethod extends Model<PayoutMethodResource, PayoutMethod> {
  id = Id.none

  @observable type = 'Stripe' as const
  @observable stripeAccountId = ''
  @observable userId: Id = ''

  constructor() {
    super()

    makeObservable(this)
  }

  /**
   * Parses the attrs from resource model.
   */
  parse(attrs: Partial<PayoutMethodResource>): Partial<PayoutMethod> {
    return {
      id: attrs.id,
      type: attrs.type,
      stripeAccountId: attrs.stripe_account_id,
      userId: attrs.user_id,
    }
  }
}
